import { NgModule } from '@angular/core';
import { UserDetailScreenComponent } from './user-detail.screen.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [UserDetailScreenComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    TranslateModule,
    ComponentsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: '',
        component: UserDetailScreenComponent,
      },
    ]),
  ],
})
export class UserDetailScreenModule {}
